import MessageCenter from './MessageCenter';

export default MessageCenter;
